// @flow
/* eslint-disable import/prefer-default-export */
import { makeGetRequest } from 'api/fetchCalls'

export async function getVersion(): Promise<{ version: string }> {
  return await makeGetRequest(`${process.env.REACT_APP_API_URL || ''}/version`)
}
